import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Deeplink: /dl/accessories?model=<id>&year=<id>&language=en|ar&show_3d=1&category_id=<id>
// Example Bronco: /dl/accessories?model=29&year=1&language=en
// Example with Show 3D only: /dl/accessories?model=29&year=1&language=en&show_3d=1
// Example with category: /dl/accessories?model=29&year=1&language=en&category_id=12
function AccessoriesDeepLink() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const model = searchParams.get('model') || searchParams.get('model_id');
        const year = searchParams.get('year') || searchParams.get('year_id') || 'all';
        const language = searchParams.get('language') || 'en';
        const show3d = searchParams.get('show_3d') || searchParams.get('show3d');
        const show3dOnly =
            process.env.REACT_APP_BRAND_ID === '1' && (show3d === '1' || show3d === 'true');
        const categoryId = searchParams.get('category_id') || searchParams.get('category');

        if (language) localStorage.setItem('language', language);
        if (model) localStorage.setItem('selectedModel', model);
        localStorage.setItem('selectedYear', year || 'all');
        if (categoryId) localStorage.setItem('selectedCategory', categoryId);

        navigate('/accessory', {
            state: {
                selectedModel: model || undefined,
                selectedYear: year || undefined,
                show3dOnly: show3dOnly || undefined,
                categoryId: categoryId || undefined
            }
        });
    }, [navigate, location]);

    // Render a loading state while redirecting
    return (
        <div className="loading">
            <p>Loading...</p>
        </div>
    );
}

export default AccessoriesDeepLink;